import { useRef } from "react";

interface UseSwipeNavigationOptions {
    currentIndex: number;
    maxIndex: number;
    onChange: (index: number) => void;
    threshold?: number;
}

export function useSwipeNavigation({ currentIndex, maxIndex, onChange, threshold = 50 }: UseSwipeNavigationOptions) {
    const touchStartX = useRef<number | null>(null);
    const touchEndX = useRef<number | null>(null);

    const handleTouchStart = (e: React.TouchEvent) => {
        touchEndX.current = null;
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchMove = (e: React.TouchEvent) => {
        touchEndX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
        if (touchStartX.current === null || touchEndX.current === null) return;

        const diff = touchStartX.current - touchEndX.current;

        if (Math.abs(diff) < threshold) {
            touchStartX.current = null;
            touchEndX.current = null;
            return;
        }

        if (diff > 0 && currentIndex < maxIndex) {
            onChange(currentIndex + 1);
        }

        if (diff < 0 && currentIndex > 0) {
            onChange(currentIndex - 1);
        }

        touchStartX.current = null;
        touchEndX.current = null;
    };

    return { handleTouchStart, handleTouchMove, handleTouchEnd };
}
